module.exports = __webpack_public_path__ + "static/media/11NEPAD9.b195c988.jpg";